export default __webpack_public_path__ + "static/media/Carmen Montano.42680954.jpg";